import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { SupplierStrategyPage } from '@/areas/suppliers/Suppliers/SupplierStrategyPage';
import { canViewSupplierStrategy } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/next/suppliers/strategy')({
    staticData: { access: { permissions: canViewSupplierStrategy }, chrome: 'none' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <SupplierStrategyPage />;
}
